/** Opens the demo call scheduler Calendly widget and reports to Plausible */
export default function openDemoCallScheduler() {
	// Open Calendly
	window.Calendly?.initPopupWidget({
		url: 'https://calendly.com/hoa-express/demo-call',
	});
	
	
	// Report to Plausible
	window.plausible('Opened demo scheduler');
}
